<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Items
            <div class="settings-header__btn">
              <el-button
              type="success"
              size="mini"
              @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div class="setting-component">
            <div class="wrap">
              <div class="wrap__tree">

                <div class="nav-tree" style="margin-bottom: 20px;">
                  <el-button
                    @click="openModalCreate"
                    class="nav-tree__item"
                    style="margin-right: 20px;"
                    size="mini"
                    type="primary"
                    plain
                    icon="el-icon-plus">Add New Items</el-button>

                  <el-input
                    v-model="name"
                    @change="filterName"
                    placeholder="Search Code / Name"
                    size="mini"
                    clearable
                    style="width: 200px; margin-right: 20px;"></el-input>

                  <el-select v-model="typeId" @change="filterType" placeholder="Item Type" size="mini" clearable filterable>
                    <el-option v-for="item in itemTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>

                </div>

                <el-table
                  max-height="650"
                  :data="tableData"
                  @cell-click="cellClick"
                  :empty-text="$t('general_noData')"
                  style="width: 100%">
                  <el-table-column
                    label="ID"
                    type="index"
                    align="center"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    sortable
                    prop="type.name"
                    label="Item Type"
                    width="260"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="code"
                    label="Item Code"
                    width="170">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="Item Name">
                  </el-table-column>
                  <el-table-column
                    label="Purchase Price"
                    width="200"
                    align="right">
                    <template slot-scope="scope">
                      <div v-if="scope.row.purchasePrice" v-text="scope.row.purchasePrice ? formatPrice(scope.row.purchasePrice) : ''"></div>
                      <div v-if="scope.row.costPrice" v-text="scope.row.costPrice ? formatPrice(scope.row.costPrice) : ''"></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Sell Price"
                    width="200"
                    align="right">
                    <template slot-scope="scope">
                      <div v-if="scope.row.sellPrice" v-text="formatPrice(scope.row.sellPrice)"></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    label="History"
                    align="center">
                    <template slot-scope="scope">
                      <div @click="setHistory(scope.row)" style="display: flex; justify-content: center; align-items: center; cursor: pointer;">
                        <img src="@/assets/img/history.png" alt="History" height="24px">
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="250"
                    align="center"
                    :label="$t('settings_accountThink_inventory_operations')">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="primary"
                        plain
                        icon="el-icon-edit"
                        @click="handleUpdate(scope.row)"></el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        plain
                        icon="el-icon-delete"
                        @click="handleDelete(scope.row)"></el-button>
                      <el-button
                        size="mini"
                        :type="scope.row.active ? 'danger' : 'success'"
                        plain
                        :icon="scope.row.active ? 'el-icon-circle-close' : 'el-icon-circle-plus-outline'"
                        @click="handleStatus(scope.row)">{{ scope.row.active ? $t('settings_mailTemplates_inactive') : $t('settings_mailTemplates_active')}}</el-button>
                    </template>
                  </el-table-column>
                </el-table>

              </div>
            </div>

            <modal-history :historyList='historyList' ref="openHistory"></modal-history>
            <create-update-modal @loadList="loadList" :itemTypeList="itemTypeList" ref="createUpdateModal"></create-update-modal>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import CreateUpdateModal from '@/components/settings/items/CreateUpdateModal.vue'
  import ModalHistory from '@/components/journalAndGl/historyJournalEntry.vue'

  export default {
    name: "items",
    components: {
      CreateUpdateModal,
      ModalHistory,
    },
    data() {
      return {
        tableData: [],
        historyList: [],
        moment:moment,
        name: null,
        typeId: null,
        itemTypeList: [],
      }
    },
    mounted() {
      this.loadList()
      this.getItemTypeList()
    },
    methods: {
      filterName(value) {
        this.typeId = null
        if (value === '') this.name = null
        this.loadList()
      },
      filterType(value) {
        this.name = null
        if (value === '') this.typeId = null
        this.loadList()
      },
      async loadList(){
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items/list?companyId=${this.$route.query.companyId}&name=${this.name}&typeId=${this.typeId}&warehouseId=null`)
          this.tableData = data.list
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      async getItemTypeList() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items/directories?companyId=${this.$route.query.companyId}&typeId=null`)
          console.log("🚀 ~ file: CreateUpdateModal.vue:108 ~ directories ~ data:", data)
          this.itemTypeList = data.directories.itemsType
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      async setHistory(row) {
        let loader = this.$loading.show();
        try {
          const { data } = await axios.get(`/api/v1/items/history?companyId=${this.$route.query.companyId}&id=${row.id}`)
          this.historyList = data.list
          this.$refs.openHistory.openModal()
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      openModalCreate(){
        this.$refs.createUpdateModal.openModal({ isCreate: true })
      },
      handleUpdate(row) {
        this.$refs.createUpdateModal.openModal({ isCreate: false, row })
      },
      async handleDelete(row) {
        this.$confirm('This will permanently delete. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(async () => {
          let loader = this.$loading.show();
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            await axios.delete(`/api/v1/items?id=${row.id}`)
            await this.loadList()
            loader.hide()
            this.$message({ type: 'success', message: 'Delete completed' });
          } catch (error) {
            console.log('An error occurred:', error);
            loader.hide()
          }

        }).catch(() => {
          this.$message({ type: 'info', message: 'Delete canceled' });
        });
      },
      async handleStatus(row) {
        let loader = this.$loading.show()
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
            await axios.put(`/api/v1/items-status?id=${row.id}`, {
              status: !row.active
            })
            await this.loadList()
            loader.hide()
            this.$message({ type: 'success', message: !row.active ? 'Activate' : 'Deactivate' });
          } catch (error) {
            console.log('An error occurred:', error);
            loader.hide()
          }
      },
      routerLink(page) {
        this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      cellClick (row, column, cell, event) {
        if (column.label !== 'Action' && column.label !== 'History') {
          this.$refs.createUpdateModal.openModal({ isCreate: false, row, onlyInfo: true })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}
.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
